import React, { useEffect, useState } from "react";
import Autosuggest from "react-autosuggest";
import { getAirportsDetails } from "app/services/charterService";

const AirportDeparture = ({ index, setFieldValue, initialValue }) => {
  const [value, setValue] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  /* =========================
     🔹 Set Initial Value (Edit Mode)
  ========================== */
  useEffect(() => {
    if (initialValue) {
      setValue(initialValue.label);
      setSuggestions(initialValue);
      setFieldValue(
        `flightLegs.onward[${index}].airportDepartureId`,
        initialValue.id,
      );
    }
  }, [initialValue, index, setFieldValue]);

  /* =========================
     🔹 Fetch Suggestions
  ========================== */
  const getSuggestions = async (inputValue) => {
    if (!inputValue) return [];

    try {
      const { data } = await getAirportsDetails(inputValue);

      if (!data) return [];

      return data.map((detail) => ({
        id: detail.id,
        label: `${detail.cityName} ${detail.cityCode}`,
      }));
    } catch (error) {
      console.error("Error fetching airports:", error);
      return [];
    }
  };

  /* =========================
     🔹 When User Types
  ========================== */
  const onChange = (event, { newValue }) => {
    setValue(newValue || "");

    // Reset Formik value when typing manually
    setFieldValue(`flightLegs.onward[${index}].airportDepartureId`, "");
  };

  /* =========================
     🔹 Suggestion Selected
  ========================== */
  const onSuggestionSelected = (event, { suggestion }) => {
    setValue(suggestion.label);

    setFieldValue(
      `flightLegs.onward[${index}].airportDepartureId`,
      suggestion.id,
    );
  };

  /* =========================
     🔹 Load Suggestions
  ========================== */
  const onSuggestionsFetchRequested = async ({ value }) => {
    const results = await getSuggestions(value);
    setSuggestions(results || []);
  };

  /* =========================
     🔹 Clear Suggestions
  ========================== */
  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  };

  const inputProps = {
    placeholder: "Airport Departure",
    value: value || "", // Safety: never undefined
    onChange,
    className: "form-control",
    id: `flightLegs.onward[${index}].airportDepartureId`,
    name: `flightLegs.onward[${index}].airportDepartureId`,
  };

  return (
    <Autosuggest
      suggestions={suggestions}
      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
      onSuggestionsClearRequested={onSuggestionsClearRequested}
      getSuggestionValue={(suggestion) => suggestion.label} // Must return string
      renderSuggestion={(suggestion) => <div>{suggestion.label}</div>}
      onSuggestionSelected={onSuggestionSelected}
      inputProps={inputProps}
    />
  );
};

export default AirportDeparture;
